import { render } from "./StatusArea.vue?vue&type=template&id=2e5e8958&scoped=true"
import script from "./StatusArea.vue?vue&type=script&lang=js"
export * from "./StatusArea.vue?vue&type=script&lang=js"

import "./StatusArea.vue?vue&type=style&index=0&id=2e5e8958&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e5e8958"]])

export default __exports__